import { AppLayout } from "@bcc/components/app-layout";
import { DEFAULT_ORDER_STATUS } from "@bcc/components/orders/constants";
import { OrderWaitingSummaryView } from "@bcc/components/views/order-waiting-summary-view";
import { usePurchaseOrdersState } from "@client-shared/providers/purchase-orders";
import { useVendorContext } from "@client-shared/providers/vendor";
import { decodeCustomerAccountNumbers } from "@client-shared/utilities/customerAccountUtilities";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

export function OrderWaitingSummaryPage() {
  const [, , { initialize }] = usePurchaseOrdersState();
  const [{ initialized: isVendorInitialized }] = useVendorContext();
  const { carrierAccountId } = useParams<{ carrierAccountId?: string }>();

  const customerAccountNumbers = useMemo<string[]>(() => {
    if (!carrierAccountId) return [];
    try {
      return decodeCustomerAccountNumbers(carrierAccountId);
    } catch {
      return [];
    }
  }, [carrierAccountId]);

  useEffect(() => {
    if (!isVendorInitialized) return;
    initialize({
      params: {
        customerAccountNumbers,
        sortByCreatedAt: "desc",
        orderStatus: [DEFAULT_ORDER_STATUS],
      },
    });
  }, [isVendorInitialized, customerAccountNumbers, initialize]);

  return (
    <AppLayout>
      <OrderWaitingSummaryView />
    </AppLayout>
  );
}
